export const DEFAULT_TAB_KEY = 'all';
